<template>
  <div class="order-modal order-modal__rate">
    <div class="order-modal__head">
      <div class="order-modal__title mb10">
        <span>Rating</span>

        <button @click="close" class="order-modal__address-close">
          <img src="@/assets/images//close.svg" width="24px" alt />
        </button>
      </div>
    </div>

    <div class="order-modal__body p30">
      <div class="rate mb30">
        <p class="rate__title">{{ $t("forms.rate_the_master") }}</p>

        <div class="rate__items">
          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-master', 1)"
            data-id="1"
            data-type="rate-master"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-master-1"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-master', 2)"
            data-id="2"
            data-type="rate-master"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-master-2"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-master', 3)"
            data-id="3"
            data-type="rate-master"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-master-3"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-master', 4)"
            data-id="4"
            data-type="rate-master"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-master-4"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-master', 5)"
            data-id="5"
            data-type="rate-master"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-master-5"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="rate mb30">
        <p class="rate__title">{{ $t("forms.rate_the_service") }}</p>

        <div class="rate__items">
          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-service', 1)"
            data-id="1"
            data-type="rate-service"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-service-1"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-service', 2)"
            data-id="2"
            data-type="rate-service"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-service-2"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-service', 3)"
            data-id="3"
            data-type="rate-service"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-service-3"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-service', 4)"
            data-id="4"
            data-type="rate-service"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-service-4"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>

          <div
            class="rate__item"
            @mouseenter="paintStars"
            @mouseleave="unpaintStars"
            @click="rate('rate-service', 5)"
            data-id="5"
            data-type="rate-service"
          >
            <svg
              width="44"
              height="44"
              viewBox="0 0 42 40"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="rate-star"
              ref="rate-service-5"
            >
              <path
                id="Star/Empty"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M21.5268 32.1101C21.2041 31.9101 20.7959 31.9101 20.4732 32.1101L10.1506 38.5081C9.38914 38.98 8.43903 38.2897 8.65257 37.4197L11.5475 25.6252C11.638 25.2565 11.5119 24.8683 11.2219 24.6232L1.94725 16.7828C1.26313 16.2045 1.62604 15.0876 2.51943 15.0218L14.6312 14.1304C15.0099 14.1025 15.3401 13.8626 15.4836 13.5111L20.0742 2.26756C20.4128 1.43822 21.5872 1.43822 21.9258 2.26756L26.5164 13.5111C26.6599 13.8626 26.9901 14.1025 27.3688 14.1304L39.4806 15.0218C40.374 15.0876 40.7369 16.2045 40.0528 16.7828L30.7781 24.6232C30.4881 24.8683 30.362 25.2565 30.4525 25.6252L33.3474 37.4197C33.561 38.2897 32.6109 38.98 31.8494 38.5081L21.5268 32.1101Z"
                stroke="#F8CC1C"
                stroke-width="1.4"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="rate__info mb30">
        <textarea
          class="rate__description"
          cols="30"
          rows="10"
          :placeholder="$t('forms.any_comments')"
          v-model="form.comment"
        ></textarea>
      </div>

      <div class="order-modal__info order-modal__info_center">
        <button
          class="btn btn_w240"
          @click="doAction"
          :disabled="!isValid"
          :class="{
            btn_disabled: !isValid  
          }"
        >{{ $t("buttons.rate") }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";

export default {
  name: "rate-modal",
  data() {
    return {
      serviceStars: null,
      masterStars: null,

      form: {
        company_rating: null,
        master_rating: null,
        comment: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      order: "orders/order"
    }),
    isValid() {
      if (this.form.company_rating == null) return false;
      if (this.form.master_rating == null) return false;
      return true;
    }
  },
  methods: {
    ...mapMutations({
      setState: "main/setState"
    }),
    ...mapActions({
      rateOrder: "orders/rate"
    }),
    close() {
      this.setState({
        key: "mainModal",
        value: false
      });
    },

    rate(type, id) {
      const elements =
        type == "rate-master" ? this.masterStars : this.serviceStars;

      this.unmark(elements, "rate-star_hover");
      this.unmark(elements, "rate-star_active");

      const mutatedElements = this.sliceElements(elements, id);
      this.mark(mutatedElements, "rate-star_active");

      if (type == "rate-master") this.form.master_rating = id;
      else this.form.company_rating = id;
    },

    paintStars({ target }) {
      const id = target.getAttribute("data-id");
      const elements =
        target.getAttribute("data-type") == "rate-master"
          ? this.masterStars
          : this.serviceStars;

      const mutatedElements = this.sliceElements(elements, id);
      this.mark(mutatedElements, "rate-star_hover");
    },
    unpaintStars({ target }) {
      const elements =
        target.getAttribute("data-type") == "rate-master"
          ? this.masterStars
          : this.serviceStars;

      this.unmark(elements, "rate-star_hover");
    },

    unmark(elements, className) {
      elements.forEach(element => {
        element.classList.remove(className);
      });
    },
    mark(elements, className) {
      elements.forEach(element => {
        if (element == null) return;

        element.classList.add(className);
      });
    },
    sliceElements(elements, till) {
      return elements.slice(0, till);
    },

    getRefs(type) {
      return [
        this.$refs[`${type}-1`],
        this.$refs[`${type}-2`],
        this.$refs[`${type}-3`],
        this.$refs[`${type}-4`],
        this.$refs[`${type}-5`]
      ];
    },
    clearRefs() {
      this.masterStars = null;
      this.serviceStars = null;
    },

    async doAction() {
      await this.rateOrder({
        id: this.order.id,
        form: this.form
      });
      this.$log("orderStatus_rate");
      this.$emit("fetch");

      this.close();
    }
  },
  mounted() {
    this.masterStars = this.getRefs("rate-master");
    this.serviceStars = this.getRefs("rate-service");
    this.$log("orderStatus_paymentReceived");
  },
  destroyed() {
    this.clearRefs();
  }
};

/**
 * on click, make this svg and all prevs active
 * on hover, make this svg and all prevs hovered
 */
</script>

<style lang="scss">
.order-modal {
  &__rate {
    max-width: 380px;
    margin: 0 auto;
    position: relative;
  }
}

.rate {
  &__items {
    display: flex;
    justify-content: center;
  }

  &__title {
    width: 100%;
    max-width: 240px;
    font-size: 16px;
    color: #0c0c0c;
    margin-bottom: 12px;
  }

  &__item {
    &:not(:last-child) {
      margin-right: 4px;
    }
  }

  &__description {
    width: 100%;
    height: 88px;
    background: #f2f2f2;
    border-radius: 10px;
    border: none;
    outline: none;
    padding: 14px 16px;
    box-sizing: border-box;
  }

  &__cta {
    display: flex;
    justify-content: center;
  }

  &-star {
    cursor: pointer;
    transition: all 0.2s ease-out;

    &_active {
      fill: rgba(248, 204, 28, 1);
    }

    &_hover {
      fill: rgba(248, 204, 28, 0.5) !important;
    }
  }
}
</style>
